"use client";

import React from "react";
import { ArrowRight, ShoppingBag } from "lucide-react";

/**
 * CreateWebshop — Section 7: Final CTA
 * Drop-in für: src/pages/CreateWebshop/sections/BuchungCallToAction.tsx
 */

export default function BuchungCallToAction() {
  return <section className="dark text-white relative w-full py-24 lg:py-32 overflow-hidden" style={{
    backgroundColor: "hsl(16,88%,54%)"
  }}>
      <div className="absolute inset-0 bg-gradient-to-br from-primary to-orange-600 shadow-[inset_0_0_60px_rgba(0,0,0,0.1)] z-0" />
      <div className="absolute inset-0 bg-white/5 z-0 pointer-events-none" />

      <div className="relative z-10 container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center space-y-8">
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 backdrop-blur-sm rounded-full px-3 py-1 text-xs font-medium text-white">
            <ShoppingBag className="w-3 h-3" />
            Pro Webshop · CHF 144 / Monat
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white drop-shadow-md leading-tight">
            Bereit für Ihren Schweizer Webshop?
          </h2>
          <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto font-medium leading-relaxed">
            Bestellen Sie jetzt — wir bauen Ihren Shop in 5 Werktagen, mit
            Twint, Stripe und allem, was dazu gehört.
          </p>
          <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href="https://dashboard.pagemaker24.ch/checkout?product_id=518&period=yearly" className="group inline-flex items-center justify-center gap-2 bg-white rounded-lg px-10 py-4 text-lg font-bold shadow-2xl transition-all duration-300 hover:bg-white/95 hover:scale-105" style={{
            color: "hsl(16,88%,54%)"
          }}>
              Webshop bestellen
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </a>
            <a href="mailto:info@pagemaker24.ch?subject=Webshop%20Anfrage" className="text-white/90 underline underline-offset-4 text-sm hover:text-white transition-colors">
              Oder per Mail anfragen
            </a>
          </div>
        </div>
      </div>
    </section>;
}